<template>
    <!-- Fragt im Button selbst nach: ein Bestätigungsdialog läge unter der
         Schublade bzw. dem Dialog, in dem der Button steht. -->
    <div
        v-if="confirming"
        class="flex flex-wrap items-center justify-end gap-2"
        data-testid="vectorize-cancel-confirm"
    >
        <span class="text-xs">{{ t("vectorize.queue.cancel_confirm") }}</span>
        <SmuButton
            size="sm"
            variant="outline"
            color="secondary"
            :disabled="cancelling"
            @click="confirming = false"
        >
            {{ t("vectorize.queue.cancel_keep") }}
        </SmuButton>
        <SmuButton
            size="sm"
            color="danger"
            :disabled="cancelling"
            data-testid="vectorize-cancel-confirm-button"
            @click="confirm"
        >
            {{ t("vectorize.queue.cancel_confirm_button") }}
        </SmuButton>
    </div>
    <SmuButton
        v-else
        size="sm"
        variant="outline"
        color="secondary"
        data-testid="vectorize-cancel"
        @click="confirming = true"
    >
        <SmuIcon icon="circle-stop" type="light" class="mr-1" />
        {{ t("vectorize.queue.cancel") }}
    </SmuButton>
</template>

<script setup lang="ts">
import { SmuButton, SmuIcon } from "@smakecloud/smake-ui";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{ taskId: string }>();

const { t } = useI18n();
const store = useVectorizeTaskStore();

const confirming = ref<boolean>(false);
const cancelling = ref<boolean>(false);

async function confirm() {
    cancelling.value = true;

    try {
        await store.cancel(props.taskId);
    } finally {
        cancelling.value = false;
        confirming.value = false;
    }
}
</script>
